module.exports = __webpack_public_path__ + "img/193.1ea2a66f.jpg";